import { useEffect, useMemo } from 'react';

import { MANUAL_SUGGEST_IMPROVEMENT } from '../../../const';
import { useLocalActions } from '../store';

export const useSaveActualInstructions = (selectedOption, manualInstructions) => {
  const localActions = useLocalActions();

  const actualInstructions = useMemo(() => {
    const isManualInstructions = selectedOption === MANUAL_SUGGEST_IMPROVEMENT;

    if (isManualInstructions) {
      return manualInstructions;
    }

    return undefined;
  }, [selectedOption, manualInstructions]);

  useEffect(() => {
    localActions.setRewriteInstructions(actualInstructions);
  }, [actualInstructions, localActions]);
};
